module.exports = __webpack_public_path__ + "img/linea1-2.b68b19c1.png";